module.exports = __webpack_public_path__ + "img/Pic_SFY_Boy.548acfff.png";